import { atom } from 'recoil'

const enum FtueFailures {
  AccountCreationFailure = 'AccountCreationFailure',
  TrendUpdateFailure = 'TrendUpdateFailure',
  OrganizationCreationFailure = 'OrganizationCreationFailure',
}

const ftueFailStateAtom = atom<FtueFailures | null>({
  key: 'ftueFailState',
  default: null,
})

export { ftueFailStateAtom, FtueFailures }
